import { Stepper } from '@linktivity/link-ui';
import Price from '@link/share/components/Price';
import type { UnitStepperProps } from './UnitStepper.types';
import styles from './unitStepper.module.css';

/** One ticket type — 大人 ¥3,000 [- 2 +] */
const UnitStepper = ({
  name,
  amount,
  currency,
  quantity,
  max,
  onChange
}: UnitStepperProps) => (
  <div className={styles.row}>
    <div>
      <div className={styles.name}>{name}</div>
      <Price className={styles.price} amount={amount} currencyCode={currency} />
    </div>
    <Stepper value={quantity} max={max} onChange={onChange} />
  </div>
);

export default UnitStepper;
